import { compose } from '@fluentui/react-bindings';
import { commonPropTypes } from '../../utils';
import { Box } from '../Box/Box';
export var dividerContentClassName = 'ui-divider__content';

/**
 * A DividerContent provides a content for the Divider.
 */
export var DividerContent = /*#__PURE__*/function () {
  var DividerContent = compose(Box, {
    className: dividerContentClassName,
    displayName: 'DividerContent',
    overrideStyles: true
  });
  DividerContent.propTypes = commonPropTypes.createCommon();
  return DividerContent;
}();
//# sourceMappingURL=DividerContent.js.map
